import { useEffect } from 'react';
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import RecruitHero from './components/RecruitHero';
import JobDetails from './components/JobDetails';
import WorkEnvironment from './components/WorkEnvironment';

const RecruitPage = () => {
  useEffect(() => {
    document.title = '求人情報 - 岡山市北区の訪問介護サービス｜ヘルパーステーションおかやま';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'ヘルパーステーションおかやまの求人情報。岡山市北区で訪問介護員（ヘルパー）を募集中。働きやすい環境、充実の福利厚生、資格取得支援制度あり。やりがいのある仕事で一緒に働きませんか。');
    }

    // Add JobPosting Schema
    const jobSchema = document.createElement('script');
    jobSchema.type = 'application/ld+json';
    jobSchema.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "JobPosting",
      "title": "訪問介護員（ヘルパー）",
      "description": "岡山市北区で訪問介護サービスを提供するヘルパーステーションおかやまでは、訪問介護員を募集しています。資格保有者優遇、未経験者も歓迎。充実の研修制度で安心してスタートできます。",
      "datePosted": "2025-01-01",
      "employmentType": ["FULL_TIME", "PART_TIME"],
      "hiringOrganization": {
        "@type": "Organization",
        "name": "おかやま訪問介護株式会社",
        "sameAs": `${import.meta.env.VITE_SITE_URL || 'https://helper-station-okayama.example.com'}/`,
        "logo": `${import.meta.env.VITE_SITE_URL || 'https://helper-station-okayama.example.com'}/vite.svg`
      },
      "jobLocation": {
        "@type": "Place",
        "address": {
          "@type": "PostalAddress",
          "streetAddress": "○○町1-2-3",
          "addressLocality": "岡山市北区",
          "addressRegion": "岡山県",
          "postalCode": "700-0000",
          "addressCountry": "JP"
        }
      },
      "baseSalary": {
        "@type": "MonetaryAmount",
        "currency": "JPY",
        "value": {
          "@type": "QuantitativeValue",
          "minValue": 1200,
          "maxValue": 1800,
          "unitText": "HOUR"
        }
      },
      "qualifications": "介護福祉士または介護職員初任者研修修了者優遇（未経験者も歓迎）",
      "benefits": "社会保険完備、交通費全額支給、資格取得支援制度、昇給・賞与あり"
    });
    document.head.appendChild(jobSchema);

    return () => {
      if (jobSchema.parentNode) {
        jobSchema.parentNode.removeChild(jobSchema);
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <RecruitHero />
        <JobDetails />
        <WorkEnvironment />
      </main>
      <Footer />
    </div>
  );
};

export default RecruitPage;